import DynamicForward from "./DynamicForward";

/**
 * Thin wrapper for off-hours context
 */
const OffHoursDynamicForward = (props) => {
  return <DynamicForward {...props} context="offHours" />;
};

export default OffHoursDynamicForward;
